<!-- 订单列表 -->
<template>
    <div id="kt_post" class="post flex-column-fluid">
        <!--    顶部标题-->
        <TitleCard v-if="!params.wxShopId" style="margin: 10px auto; max-width: 97%" title="广告位管理">
            <template v-slot:subTitle>
                <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                    <li class="breadcrumb-item text-muted">Ad Space Management</li>
                </ul>
            </template>
        </TitleCard>

        <div
            class="container-fluid d-flex flex-stack flex-column-fluid"
            style="padding: 0 30px"
        >
            <form action="#" style="width: 100%">
                <!--begin::Card-->
                <div class="card">
                    <!--begin::Card body-->
                    <div class="card-body">
                        <!--begin::Compact form-->
                        <div class="d-flex align-items-center">
                            <!--begin::Input group-->
                            <div class="position-relative w-md-400px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                                <!--end::Svg Icon-->
                                <input
                                    id="sTitle"
                                    v-model="topicListQuery.title"
                                    class="form-control form-control-solid ps-10"
                                    name="shopName"
                                    placeholder="广告位名称"
                                    type="text"
                                    value=""
                                />

                            </div>
                            <!--end::Input group-->

                            <!--begin::Input group-->
                            <div class="position-relative w-md-200px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                                <!--end::Svg Icon-->
                                <el-select v-model="topicListQuery.type"
                                           placeholder="请选择类型"
                                           style="margin-right: 20px;margin-left: 10px">
                                    <el-option
                                        :value="1"
                                        label="消费券">
                                    </el-option>
                                    <el-option
                                        :value="2"
                                        label="提货券">
                                    </el-option>
                                    <el-option
                                        :value="3"
                                        label="首页-轮播图">
                                    </el-option>
                                    <el-option
                                        :value="4"
                                        label="首页-金刚区">
                                    </el-option>
                                    <el-option
                                        :value="5"
                                        label="首页-子金刚区">
                                    </el-option>
                                    <el-option
                                        :value="6"
                                        label="首页-左瓷片区">
                                    </el-option>
                                    <el-option
                                        :value="7"
                                        label="首页-品牌区">
                                    </el-option>
                                    <el-option
                                        :value="8"
                                        label="首页-类目">
                                    </el-option>
                                    <el-option
                                        :value="9"
                                        label="首页-搜索">
                                    </el-option>
                                    <el-option
                                        :value="10"
                                        label="首页-右上瓷片区">
                                    </el-option>
                                    <el-option
                                        :value="11"
                                        label="首页-右上瓷片区">
                                    </el-option>
                                    <el-option
                                        :value="12"
                                        label="首页-公告">
                                    </el-option>
                                    <el-option
                                        :value="13"
                                        label="首页-胶囊区">
                                    </el-option>
                                    <el-option
                                        :value="14"
                                        label="首页-新品速递">
                                    </el-option>
                                    <el-option
                                        :value="15"
                                        label="首页-弹窗">
                                    </el-option>
                                    <el-option
                                        :value="16"
                                        label="首页-分享">
                                    </el-option>
                                    <el-option
                                        :value="17"
                                        label="商品-分享 ">
                                    </el-option>
                                    <el-option
                                        :value="18"
                                        label="商品-轮播图">
                                    </el-option>
                                    <el-option
                                        :value="19"
                                        label="商品-金刚区">
                                    </el-option>
                                    <el-option
                                        :value="20"
                                        label="首页-推荐好物">
                                    </el-option>
                                    <el-option
                                        :value="21"
                                        label="消费券-轮播图">
                                    </el-option>
                                    <el-option
                                        :value="22"
                                        label="消费券-金刚区">
                                    </el-option>
                                    <el-option
                                        :value="23"
                                        label="消费券-品牌区">
                                    </el-option>
                                    <el-option
                                        :value="24"
                                        label="消费券-类目">
                                    </el-option>
                                    <el-option
                                        :value="25"
                                        label="消费券-搜索">
                                    </el-option>
                                    <el-option
                                        :value="26"
                                        label="消费券-公告">
                                    </el-option>
                                </el-select>

                            </div>
                            <!--end::Input group-->

                            <!--begin::Input group-->
                            <div class="position-relative w-md-200px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                                <!--end::Svg Icon-->
                                <el-select v-model="topicListQuery.status"
                                           placeholder="请选择状态"
                                           style="margin-right: 20px;margin-left: 10px">
                                    <el-option
                                        :value="1"
                                        label="开启">
                                    </el-option>
                                    <el-option
                                        :value="2"
                                        label="关闭">
                                    </el-option>
                                </el-select>

                            </div>
                            <!--end::Input group-->

                            <!--begin::Input group-->
                            <div class="position-relative w-md-200px me-md-2">
                <span
                    class="svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6"
                >
                  <svg
                      height="24px"
                      version="1.1"
                      viewBox="0 0 24 24"
                      width="24px"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                  >
                    <g
                        fill="none"
                        fill-rule="evenodd"
                        stroke="none"
                        stroke-width="1"
                    >
                      <rect height="24" width="24" x="0" y="0"></rect>
                      <path
                          d="M14.2928932,16.7071068 C13.9023689,16.3165825 13.9023689,15.6834175 14.2928932,15.2928932 C14.6834175,14.9023689 15.3165825,14.9023689 15.7071068,15.2928932 L19.7071068,19.2928932 C20.0976311,19.6834175 20.0976311,20.3165825 19.7071068,20.7071068 C19.3165825,21.0976311 18.6834175,21.0976311 18.2928932,20.7071068 L14.2928932,16.7071068 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                          opacity="0.3"
                      ></path>
                      <path
                          d="M11,16 C13.7614237,16 16,13.7614237 16,11 C16,8.23857625 13.7614237,6 11,6 C8.23857625,6 6,8.23857625 6,11 C6,13.7614237 8.23857625,16 11,16 Z M11,18 C7.13400675,18 4,14.8659932 4,11 C4,7.13400675 7.13400675,4 11,4 C14.8659932,4 18,7.13400675 18,11 C18,14.8659932 14.8659932,18 11,18 Z"
                          fill="#000000"
                          fill-rule="nonzero"
                      ></path>
                    </g>
                  </svg>
                </span>
                                <!--end::Svg Icon-->
                                <el-select v-model="topicListQuery.platForm"
                                           placeholder="请选择展示平台"
                                           style="margin-right: 20px;margin-left: 10px">
                                    <el-option
                                        :value="1"
                                        label="公众号">
                                    </el-option>
                                    <el-option
                                        :value="2"
                                        label="小程序">
                                    </el-option>
                                </el-select>

                            </div>
                            <!--end::Input group-->

                            <!--begin:Action-->
                            <div class="d-flex align-items-center">
                                <div class="btn btn-primary me-5 btn-sm" @click="getTopicList">
                                    查询
                                </div>
                                <div class="btn btn-secondary me-5 btn-sm" @click="resetBtn">
                                    重置
                                </div>
                                <!--                <a
                                                    id="kt_horizontal_search_advanced_link"
                                                    class="btn btn-link"
                                                    data-bs-toggle="collapse"
                                                    href="#kt_advanced_search_form"
                                                >高级查询</a
                                                >-->

                            </div>

                        </div>

                        <!--begin::高级搜索-->
                        <div id="kt_advanced_search_form" class="collapse">
                            <!--begin::Separator-->
                            <div class="separator separator-dashed mt-9 mb-6"></div>
                            <!--end::Separator-->
                            <!--begin::Row-->
                            <div class="row g-8 mb-8">
                                <!--begin::Col-->
                                <div class="col-lg-3">
                                    <label class="fs-6 form-label fw-bolder text-dark"
                                    >上级编号</label
                                    >
                                    <br/>
                                    <el-input
                                        v-model="topicListQuery.status"
                                        clearable
                                        placeholder="请输入要查询的上级编号"
                                    >
                                    </el-input>
                                </div>
                                <!--end::Col-->
                                <!--begin::Col-->
                                <div class="col-lg-3">
                                    <label class="fs-6 form-label fw-bolder text-dark"
                                    >手机号</label
                                    >
                                    <br/>
                                    <el-input
                                        v-model="topicListQuery.status"
                                        clearable
                                        placeholder="请输入要查询的手机号"
                                    >
                                    </el-input>
                                </div>
                                <!--end::Col-->

                            </div>
                            <!--end::Row-->
                        </div>
                        <!--end::Advance form-->

                    </div>
                    <!--end::Card body-->
                </div>
                <!--end::Card-->
            </form>
        </div>

        <div
            id="kt_content_container"
            class="container"
            style="
        margin-top: 10px;
        max-width: 98%;
        flex-direction: row !important;
        display: flex;
      "
        >
            <div id="kt_app_main" class="app-main flex-column flex-row-fluid">
                <div class="d-flex flex-column flex-column-fluid">
                    <div id="kt_app_content" class="" style="margin-bottom: 10px">
                        <!-- {{idArr}} {{ sumMoney }} -->
                        <div class="card card-flush" style="position: relative">
                            <div class="card-body">
                                <div style="position: absolute; top: 10px; right: 80px">
                                    <el-button
                                        size="small"
                                        type="primary"
                                        @click="createTopic()"
                                    >创建广告位
                                    </el-button
                                    >
                                </div>

                                <div class="modal-body py-lg-10 px-lg-10">
                                    <div id="topicTable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                                        <div class="table-responsive">
                                            <table
                                                id="topicTable"
                                                aria-describedby="topicTable_info"
                                                class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bolder no-footer dataTable"
                                                role="grid" style="width: 590px;">
                                                <!--begin::Head-->
                                                <thead class="fs-7 text-gray-400 text-uppercase">
                                                <tr role="row">
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">名称</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">展示平台</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">展示类型</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">跳转方式</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">图片</th>
                                                    <!--                          <th class="sorting_disabled" colspan="1" rowspan="1">选品库</th>-->
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">是否上架</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">创建时间</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">排序</th>
                                                    <th class="sorting_disabled" colspan="1" rowspan="1">操作</th>
                                                </tr>
                                                </thead>
                                                <tbody id="topicTableBody" class="fs-6">

                                                <tr v-for="(item,index) in topicList" :key="index" class="odd">
                                                    <td>{{ item.title }}{{ item.jumpType }}</td>
                                                    <td>{{ item.platForm == 1 ? '公众号' : '小程序' }}</td>


                                                    <td v-if="item.type==1">消费券</td>
                                                    <td v-if="item.type==2">提货券</td>
                                                    <td v-if="item.type==3">首页-轮播图</td>
                                                    <td v-if="item.type==4">首页-金刚区</td>
                                                    <td v-if="item.type==5">首页-子金刚区</td>
                                                    <td v-if="item.type==6">首页-左瓷片区</td>
                                                    <td v-if="item.type==7">首页-品牌区</td>
                                                    <td v-if="item.type==8">首页-类目</td>
                                                    <td v-if="item.type==9">首页-搜索</td>
                                                    <td v-if="item.type==10">首页-右上瓷片区</td>
                                                    <td v-if="item.type==11">消费券</td>
                                                    <td v-if="item.type==12">首页-公告</td>
                                                    <td v-if="item.type==13">首页-胶囊区</td>
                                                    <td v-if="item.type==14">首页-新品速递</td>
                                                    <td v-if="item.type==15">首页-弹窗</td>
                                                    <td v-if="item.type==16">首页-分享</td>
                                                    <td v-if="item.type==17">商品-分享</td>
                                                    <td v-if="item.type==18">商品-轮播图</td>
                                                    <td v-if="item.type==19">商品-金刚区</td>
                                                    <td v-if="item.type==20">首页-推荐好物</td>
                                                    <td v-if="item.type==21">消费券-轮播图</td>
                                                    <td v-if="item.type==22">消费券-金刚区</td>
                                                    <td v-if="item.type==23">消费券-品牌区</td>
                                                    <td v-if="item.type==24">消费券-类目</td>
                                                    <td v-if="item.type==25">消费券-搜索</td>
                                                    <td v-if="item.type==26">消费券-公告</td>
                                                    <td v-if="item.jumpType==1">跳转专题</td>
                                                    <td v-else-if="item.jumpType==2">自定义path</td>
                                                    <td v-else-if="item.jumpType==3">跳转链接（公众号）</td>
                                                    <td v-else></td>

                                                    <td><img :src="item.imgUrl"
                                                             style="width:190px;height:57px;object-fit: contain;"></td>
                                                    <!--                          <td>{{ item.jumpDataStr }}</td>-->
                                                    <td>
                                                        <el-switch
                                                            v-model="item.status"
                                                            active-text="启动"
                                                            :active-value="1"
                                                            :inactive-value="2"
                                                            inactive-text="关闭"
                                                            @change="changeBannerConfigStatus(item.id, item.status)"
                                                        >
                                                        </el-switch>
                                                    </td>
                                                    <td>{{ item.createTime }}</td>
                                                    <td>{{ item.sort ? item.sort : '暂无' }}</td>
                                                    <td><a class="btn btn-info btn-sm px-4 mx-sm-1 my-sm-1"
                                                           @click="editTopic(item.id)">&nbsp;编辑</a>
                                                        <!--                            <a v-if="tabindex==1||tabindex==2"  class="btn btn-success btn-sm px-4 mx-sm-1 my-sm-1"
                                                                                      @click="editGoods(item.id)">&nbsp;商品维护</a>-->
                                                        <a class="btn btn-danger btn-sm px-4 mx-sm-1 my-sm-1"
                                                           @click="deleteTopic(item.id)">&nbsp;删除</a></td>
                                                </tr>
                                                </tbody>

                                            </table>
                                            <div id="topicTable_processing" class="dataTables_processing"
                                                 style="display: none;"></div>
                                        </div>
                                        <el-pagination :current-page="topicListQuery.pageIndex"
                                                       :page-size="topicListQuery.pageSize"
                                                       :page-sizes="[10,20,30]" :total="count"
                                                       background
                                                       layout="total, sizes, prev, pager, next, jumper"
                                                       style="display:flex;justify-content:flex-end"
                                                       @size-change="handleSizeChange"
                                                       @current-change="handleCurrentChange">
                                        </el-pagination>
                                    </div>
                                </div>
                                <!--end::Modal body-->
                                <el-dialog v-if="saveTopicVisible" :visible.sync="saveTopicVisible" title="创建广告位"
                                           width="40%"
                                           :before-close="handleSaveClose">
                                    <template #title>
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h2 v-if="saveShopMode == 1">创建广告位</h2>
                                                <h2 v-if="saveShopMode == 2">编辑广告位</h2>
                                            </div>
                                        </div>
                                    </template>
                                    <div class="modal-body" style="width: 70%;margin-left: 15%">
                                        <el-form :model="saveTopicForm" :rules="saveTopicFormRule" ref="saveTopicForm"
                                                 label-position="top">
                                            <el-form-item prop="title">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">标题名称</label>
                                            </span>
                                                <el-input v-model="saveTopicForm.title"></el-input>
                                            </el-form-item>
                                            <el-form-item prop="platForm">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">展示平台</label>
                                            </span>
                                                <el-radio v-model.number="saveTopicForm.platForm" :label="1">公众号
                                                </el-radio>
                                                <el-radio v-model.number="saveTopicForm.platForm" :label="2">小程序
                                                </el-radio>
                                            </el-form-item>
                                            <el-form-item prop="type">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">展示类型</label>
                                            </span>
                                                <el-select v-model="saveTopicForm.type" placeholder="请选择">
                                                    <el-option value="1" label="消费券">消费券</el-option>
                                                    <el-option value="2" label="提货券">提货券</el-option>
                                                    <el-option value="3" label="首页-轮播图">首页-轮播图</el-option>
                                                    <el-option value="4" label="首页-金刚区">首页-金刚区</el-option>
                                                    <el-option value="5" label="首页-子金刚区">首页-子金刚区</el-option>
                                                    <el-option value="6" label="首页-左瓷片区">首页-左瓷片区</el-option>
                                                    <el-option value="7" label="首页-品牌区">首页-品牌区</el-option>
                                                    <el-option value="8" label="首页-类目">首页-类目</el-option>
                                                    <el-option value="9" label="首页-搜索">首页-搜索</el-option>
                                                    <el-option value="10" label="首页-右上瓷片区">首页-右上瓷片区
                                                    </el-option>
                                                    <el-option value="11" label="首页-右上瓷片区">首页-右上瓷片区
                                                    </el-option>
                                                    <el-option value="12" label="首页-公告">首页-公告</el-option>
                                                    <el-option value="13" label="首页-胶囊区">首页-胶囊区</el-option>
                                                    <el-option value="14" label="首页-新品速递">首页-新品速递
                                                    </el-option>
                                                    <el-option value="15" label="首页-弹窗">首页-弹窗</el-option>
                                                    <el-option value="16" label="首页-分享">首页-分享</el-option>
                                                    <el-option value="17" label="商品-分享">商品-分享</el-option>
                                                    <el-option value="18" label="商品-轮播图">商品-轮播图</el-option>
                                                    <el-option value="19" label="商品-金刚区">商品-金刚区</el-option>
                                                    <el-option value="20" label="首页-推荐好物">首页-推荐好物
                                                    </el-option>
                                                    <el-option value="21" label="消费券-轮播图">消费券-轮播图</el-option>
                                                    <el-option value="22" label="消费券-金刚区">消费券-金刚区</el-option>
                                                    <el-option value="23" label="消费券-品牌区">消费券-品牌区</el-option>
                                                    <el-option value="24" label="消费券-类目">消费券-类目</el-option>
                                                    <el-option value="25" label="消费券-搜索">消费券-搜索</el-option>
                                                    <el-option value="26" label="消费券-公告">消费券-公告</el-option>
                                                </el-select>
                                            </el-form-item>

                                            <el-form-item label="首页logo(建议尺寸：190x57)" prop="">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">展示图片</label>
                                            </span>
                                                <uploadImg moduleName="bannerConfig" :imgUrl="saveTopicForm.imgUrl"
                                                           @upload-success="uploadSuccess"
                                                           @cancel-success="cancelSuccess"></uploadImg>
                                            </el-form-item>

                                            <el-form-item label="首页logo(建议尺寸：190x57)" prop="">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">角标</label>
                                            </span>
                                                <uploadImgCornerImg moduleName="bannerConfig"
                                                                    :imgUrl="saveTopicForm.cornerImg"
                                                                    @upload-success-cornerImg="uploadCornerImgSuccess"
                                                                    @cancel-success-cornerImg="cancelCornerImgSuccess"></uploadImgCornerImg>
                                            </el-form-item>

                                            <el-form-item label="首页logo(建议尺寸：190x57)" prop="">
                                                 <span slot="label" style="display:inline-block;">
                                                     <label class="form-label fw-bolder text-dark fs-6">分享图</label>
                                                 </span>
                                                <uploadImgShareImg moduleName="bannerConfig"
                                                                   :imgUrl="saveTopicForm.shareImg"
                                                                   @upload-success-shareImg="uploadShareImgSuccess"
                                                                   @cancel-success-shareImg="cancelShareImgSuccess"></uploadImgShareImg>
                                            </el-form-item>
                                            <el-form-item prop="">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">对应文案</label>
                                            </span>
                                                <el-input v-model="saveTopicForm.showContent"></el-input>
                                            </el-form-item>

                                            <el-form-item prop="isJump" v-if="saveTopicForm.type != 8 && saveTopicForm.type != 9
                                      && saveTopicForm.type != 12 && saveTopicForm.type != 16 && saveTopicForm.type != 17 && saveTopicForm.type != '' ">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">是否跳转</label>
                                            </span>
                                                <!--                                        <el-radio v-model.number="saveTopicForm.isJump" :label="1">跳转</el-radio>-->
                                                <!--                                        <el-radio v-model.number="saveTopicForm.isJump" :label="0">不跳转</el-radio>-->
                                                <el-radio-group v-model.number="saveTopicForm.isJump">
                                                    <el-radio :label="1">跳转</el-radio>
                                                    <el-radio :label="0">不跳转</el-radio>
                                                </el-radio-group>
                                            </el-form-item>

                                            <el-form-item prop="jumpType" v-if="(saveTopicForm.type != 8 && saveTopicForm.type != 9
                                      && saveTopicForm.type != 12 && saveTopicForm.type != 16 && saveTopicForm.type != 17 && saveTopicForm.type != '') && saveTopicForm.isJump != 0 ">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">跳转方式</label>
                                            </span>
                                                <el-radio v-model.number="saveTopicForm.jumpType" :label="1">跳转专题
                                                </el-radio>
                                                <el-radio v-model.number="saveTopicForm.jumpType" :label="2">
                                                    自定义path
                                                </el-radio>
                                                <el-radio v-model.number="saveTopicForm.jumpType" :label="3">
                                                    跳转链接（公众号）
                                                </el-radio>
                                            </el-form-item>

                                            <el-form-item prop="jumpData"
                                                          v-if="(saveTopicForm.type != 12 && saveTopicForm.type != 16 && saveTopicForm.type != 17) && saveTopicForm.isJump != 0 ">
                                            <span slot="label" style="display:inline-block;">
                                                <label class="form-label fw-bolder text-dark fs-6">选品库</label>
                                            </span>
                                                <el-select v-model="saveTopicForm.jumpData" placeholder="请选择"
                                                           v-if="saveTopicForm.jumpType == 1 ||  saveTopicForm.jumpType == '' ||  saveTopicForm.jumpType == null || saveTopicForm.type == '' ">
                                                    <el-option
                                                        v-for="item in selectList"
                                                        :key="item.id"
                                                        :value="item.id"
                                                        :label="item.name"
                                                    />
                                                </el-select>
                                                <el-input v-model="saveTopicForm.jumpData"
                                                          placeholder="请输入自定义path"
                                                          v-if="(saveTopicForm.jumpType==2 && saveTopicForm.type != 8) && (saveTopicForm.jumpType==2 && saveTopicForm.type != 9)"></el-input>
                                                <el-input v-model="saveTopicForm.jumpData"
                                                          placeholder="请输入跳转链接（公众号）"
                                                          v-if="(saveTopicForm.jumpType==3 && saveTopicForm.type != 8) && (saveTopicForm.jumpType==3 && saveTopicForm.type != 9)"></el-input>
                                            </el-form-item>

                                            <el-form-item prop="sort">
                                                <span slot="label" style="display:inline-block;">
                                                    <label class="form-label fw-bolder text-dark fs-6">排序</label>
                                                </span>
                                                <el-input type="number" v-model="saveTopicForm.sort"></el-input>
                                            </el-form-item>
                                            <el-form-item prop="isShow">
                                                <span slot="label" style="display:inline-block;">
                                                    <label class="form-label fw-bolder text-dark fs-6">是否上架</label>
                                                </span>
                                                <el-switch
                                                    v-model="saveTopicForm.status"
                                                    active-text="启动"
                                                    :active-value="1"
                                                    :inactive-value="2"
                                                    inactive-text="关闭"
                                                >
                                                </el-switch>
                                            </el-form-item>

                                        </el-form>
                                    </div>

                                    <div class="modal-footer">
                                        <button v-if="saveShopMode == 1" @click="submitAddTopic" type="button"
                                                class="btn btn-primary">提交
                                        </button>
                                        <button v-if="saveShopMode == 2" @click="submitUpdateTopic" type="button"
                                                class="btn btn-primary">保存
                                        </button>
                                    </div>
                                </el-dialog>

                                <!-- 商品的弹窗 -->
                                <!--                <el-dialog v-if="wxTopicGoodsVisible" :visible.sync="wxTopicGoodsVisible" append-to-body=true title="商品管理"
                                                           width="90%">
                                                                  <template #title>
                                                                    <div class="modal-content">
                                                                      <div class="modal-header">
                                                                        <h2>商品管理</h2>
                                                                      </div>
                                                                    </div>
                                                                  </template>
                                                                  <topicGoodsModal :currentTopicId="currentTopicId"></topicGoodsModal>
                                                                </el-dialog>-->
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    </div>
</template>

<script>
import topicGoodsModal from "./components/topicGoodsModal.vue"
import sd from "silly-datetime"
import {mapState} from "vuex";
import {
    addBannerConfig,
    updateBannerConfig,
    getBannerConfigInfo,
    changeBannerConfigStatus,
    getBannerConfigList,
    deleteBannerConfig
} from "@/api/bannerConfigApi";

import uploadImg from "./uploadImg.vue"
import uploadImgCornerImg from "./uploadImgCornerImg.vue"
import uploadImgShareImg from "./uploadImgShareImg.vue"
import {getSelectList} from "@/api/groupGoodsApi";
import {changePasswordApi} from "@/api/userApi";

export default {
    name: "",
    components: {
        uploadImg, topicGoodsModal, uploadImgCornerImg, uploadImgShareImg
    },
    computed: {
        ...mapState("user", ["role"]),
    },
    // 组件的props定义,用于子组件接收父组件传值
    props: {
        currentWxShopId: {
            type: Number,
            default: null,
        },
        userTel: {
            type: String,
            default: "",
        }
    },
    // 组件的data属性
    data() {
        return {
            data: {
                successCount: 0,
                errorCount: 1,
            },
            columns: [
                {label: "订单编号", prop: "orderNo"},
                {label: "快递名字", prop: "expressName"},
                {label: "快递单号", prop: "expressNo"},
                {label: "字母单号(使用#)", prop: "otherExpressNo"},
                {label: "错误信息", prop: "errorMsg"},
            ],
            outcomeDialog: false,
            fileList: [],
            tableData: [],

            dialogVisible: false,
            index: 1,
            tabindex: 1,
            idArr: [],
            orderDateRange: [],
            orderStatus: [

                {
                    title: "活动管理",
                    count: 0,
                    icon: "ki-outline ki-note-2 fs-4 me-2",
                    hidden: false
                },
                {
                    title: "轮播管理",
                    count: 0,
                    icon: "ki-outline ki-bookmark-2 fs-4 me-2",
                    hidden: false
                },
                /* {
                   title: "线路轮播管理",
                   count: 0,
                   icon: "ki-outline ki-bookmark-2 fs-4 me-2",
                   hidden: false
                 },*/

            ],
            params: {
                pageIndex: 1,
                pageSize: 10,
                // 订单编号
                orderNo: "",
                // 订单状态
                orderStatus: "",
                // 开票状态
                invoiceState: "",
                // 订单日期
                startTime: "",
                endTime: "",
                // 下单人手机号
                telNum: this.userTel,
                // 商品来源
                fromType: "",
                wxShopId: this.currentWxShopId == null ? "" : this.currentWxShopId,
                // 收件人手机号
                tel: ""
            },
            orderStatusOptions: [
                {
                    value: "1",
                    label: "待付款",
                },
                {
                    value: "2",
                    label: "待发货",
                },
                {
                    value: "3",
                    label: "已发货",
                },
                {
                    value: "4",
                    label: "已完结",
                },
            ],
            invoiceStateOptions: [
                {
                    value: "1",
                    label: "已开票",
                },
                {
                    value: "2",
                    label: "未开票",
                },
            ],
            sourceOfGoodsOptions: [
                {
                    value: "1",
                    label: "自有商品",
                },
                {
                    value: "4",
                    label: "厂供商品",
                },
                {
                    value: "3",
                    label: "全国商品池",
                },
                {
                    value: "2",
                    label: "二级供应商",
                },
            ],
            //日期选择器 用
            pickerOptions: {
                shortcuts: [
                    {
                        text: "最近一周",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近一个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                    {
                        text: "最近三个月",
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit("pick", [start, end]);
                        },
                    },
                ],
            },
            myCashOut: {
                money: "",
            },
            sumMoney: 0,

            topicListQuery: {
                pageIndex: 1,
                pageSize: 10,
                type: '', //1：消费券 2：提货券
                title: '',
                status: '',
                platForm: '',
            },
            topicList: [],
            currentTopic: {},
            currentTopicId: -1,

            count: 0,
            saveTopicVisible: false,
            saveShopMode: 1,
            topicType: 1, //1：活动 2：轮播 创建时

            saveTopicForm: {
                title: "",
                type: "",
                imgUrl: "",
                cornerImg: "",
                shareImg: "",
                showContent: "",
                jumpData: "",
                sort: "",
                status: "",
                platForm: "",
                isJump: "",
                jumpType: "",

            },
            saveTopicFormRule: {
                title: [
                    {required: true, message: '请输入标题名称', trigger: 'blur'}
                ],
                type: [
                    {required: true, message: '请选择展示类型', trigger: 'change'}
                ],
                jumpData: [
                    {required: true, message: '请选择选品库', trigger: 'change'}
                ],
                platForm: [
                    {required: true, message: '请选择展示平台', trigger: 'change'}
                ],
                isJump: [
                    {required: true, message: '请选择是否跳转', trigger: 'change'}
                ],
                jumpType: [
                    {required: true, message: '请选择跳转方式', trigger: 'change'}
                ],


            },

            wxTopicGoodsVisible: false,
            selectList: [],


        };
    },
    // 组件的方法
    methods: {

        jumpIndex(index) {
            if (index == 3) {
                this.tabindex = 4
                this.index = 4
            } else {
                this.index = index;
                this.tabindex = index
            }
            this.topicListQuery.type = this.index;
            this.getTopicList();
        },


        async getTopicList() {
            const {data} = await getBannerConfigList(this.topicListQuery);
            this.topicList = data.rows
            this.count = data.count
        },

        createTopic() {
            this.saveTopicForm = {
                title: "",
                type: "",
                imgUrl: "",
                shareImg: "",
                cornerImg: "",
                showContent: "",
                sort: "",
                status: "",
            }
            this.initSelectList();
            this.saveShopMode = 1;
            this.saveTopicVisible = true;
        },

        handleSaveClose() {
            this.saveTopicVisible = false
            this.saveTopicForm.bannerUrl = ""
            this.saveTopicForm.title = ""
            this.saveTopicForm.sortNum = ""
            this.saveTopicForm.subTitle = ""
        },

        uploadSuccess(res) {
            console.log(res)
            this.saveTopicForm.imgUrl = res.data.fileUrl
        },
        cancelSuccess(res) {
            if (res) {
                console.log(res)
                this.saveTopicForm.imgUrl = ""
            }
        },


        uploadCornerImgSuccess(res) {
            console.log(res)
            this.saveTopicForm.cornerImg = res.data.fileUrl
        },
        cancelCornerImgSuccess(res) {
            if (res) {
                console.log(res)
                this.saveTopicForm.cornerImg = ""
            }
        },


        uploadShareImgSuccess(res) {
            console.log(res)
            this.saveTopicForm.shareImg = res.data.fileUrl
        },
        cancelShareImgSuccess(res) {
            if (res) {
                console.log(res)
                this.saveTopicForm.shareImg = ""
            }
        },

        handleCurrentChange(param) {
            this.topicListQuery.pageIndex = param
            this.getTopicList();
        },
        handleSizeChange(param) {
            this.topicListQuery.pageIndex = 1
            this.topicListQuery.pageSize = param
            this.getTopicList();
        },

        async submitAddTopic() {

            this.$refs.saveTopicForm.validate(async (valid) => {
                if (valid) {
                    const isJump = this.saveTopicForm.isJump
                    if (isJump == 0) {
                        this.saveTopicForm.jumpType = 0
                        this.saveTopicForm.jumpData = ""
                    }

                    const res = await addBannerConfig(this.saveTopicForm);
                    if (res.code == 200) {
                        this.$message({
                            type: 'success',
                            message: '创建成功!'
                        });
                        this.saveTopicVisible = false

                        await this.getTopicList()
                    }
                }
                return false;
            });


        },

        async editTopic(id) {
            this.initSelectList();
            this.saveTopicVisible = true
            const queryOne = {id: id};
            const {data} = await getBannerConfigInfo(queryOne);
            this.saveShopMode = 2
            this.currentTopic = data
            this.saveTopicForm.title = data.title
            this.saveTopicForm.type = data.type?.toString() || ''
            this.saveTopicForm.imgUrl = data.imgUrl
            this.saveTopicForm.cornerImg = data.cornerImg
            this.saveTopicForm.shareImg = data.shareImg
            this.saveTopicForm.showContent = data.showContent


            this.saveTopicForm.platForm = data.platForm
            this.saveTopicForm.isJump = data.isJump
            this.saveTopicForm.jumpType = data.jumpType

            const jumpType = data.jumpType
            if (jumpType == 1) {
                this.saveTopicForm.jumpData = data.jumpData != null ? Number(data.jumpData) : null
            } else {
                this.saveTopicForm.jumpData = data.jumpData
            }

            this.saveTopicForm.sort = data.sort
            this.saveTopicForm.status = data.status
        },

        async submitUpdateTopic() {
            this.currentTopic.title = this.saveTopicForm.title
            this.currentTopic.type = this.saveTopicForm.type
            this.currentTopic.imgUrl = this.saveTopicForm.imgUrl
            this.currentTopic.cornerImg = this.saveTopicForm.cornerImg
            this.currentTopic.shareImg = this.saveTopicForm.shareImg
            this.currentTopic.showContent = this.saveTopicForm.showContent
            this.currentTopic.jumpData = this.saveTopicForm.jumpData
            this.currentTopic.sort = this.saveTopicForm.sort
            this.currentTopic.status = this.saveTopicForm.status

            this.currentTopic.platForm = this.saveTopicForm.platForm
            this.currentTopic.isJump = this.saveTopicForm.isJump
            this.currentTopic.jumpType = this.saveTopicForm.jumpType

            const isJump = this.saveTopicForm.isJump
            if (isJump == 0) {
                this.currentTopic.jumpType = 0
                this.currentTopic.jumpData = ""
            }

            this.$refs.saveTopicForm.validate(async (valid) => {
                if (valid) {
                    const res = await updateBannerConfig(this.currentTopic);
                    this.$message({
                        type: 'success',
                        message: '编辑成功!'
                    });
                    this.saveTopicVisible = false
                    await this.getTopicList()
                }
                return false;
            });


        },

        editGoods(currentTopcId) {
            this.currentTopicId = currentTopcId
            this.wxTopicGoodsVisible = true
        },

        async changeBannerConfigStatus(id, status) {
            const deleteParam = {
                id: id,
                status: status
            };
            const res = await changeBannerConfigStatus(deleteParam);
            if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '修改成功!'
                });
                await this.getTopicList()
            }
        },


        async deleteTopic(id) {
            const deleteParam = {
                id: id,
            };
            const res = await deleteBannerConfig(deleteParam);
            if (res.code == 200) {
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
                await this.getTopicList()
            }
        },

        //初始选品库
        async initSelectList() {
            let {data} = await getSelectList({
                parentId: 0,
            });
            this.selectList = data.list;
        },

        resetBtn() {
            this.topicListQuery = {
                pageIndex: 1,
                pageSize: 10,
                title: "",
                type: "",
                status: "",
            };
            this.getGoodsGroup();
        },


    },
    // 在created钩子中执行的操作
    created() {
        this.getTopicList()

    },
    filters: {
        dataFormat(date) {
            return sd.format(date, "YYYY-MM-DD HH:mm:ss");
        },
        format(num) {
            return (
                Number(num)
                    .toFixed(2)
                    .replace(/\d(?=(\d{3})+\.)/g, "$&,") + " 元"
            );
        },
    },
};
</script>

<!-- 组件的样式 -->
<style scoped>
.el-range-separator {
    padding: 0;
}
</style>
